import React from 'react';
import { makeStyles, TextField } from '@material-ui/core';

export default function Parameter(props) {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <div className={classes.label}>
                {props.param.name}
            </div>
            {props.speed > 0 ?
                <TextField id="outlined-search" label="" variant="outlined" value={props.speed} className={classes.textField} size="small" onChange={(e) => props.parameterChanged(e, props.param.id, props.param.values[0].number)} /> :
                props.rpmPump > 0 ?
                    <TextField id="outlined-search" label="" variant="outlined" value={props.rpmPump} className={classes.textField} size="small" onChange={(e) => props.parameterChanged(e, props.param.id, props.param.values[0].number)} />
                    :
                    props.param.values[0].value !== null ?
                        <TextField id="outlined-search" label="" variant="outlined" value={props.param.values[0].value} className={classes.textField} size="small" onChange={(e) => props.parameterChanged(e, props.param.id, props.param.values[0].number)} />
                        :
                        <TextField id="outlined-search" label="" variant="outlined" className={classes.textField} size="small" onChange={(e) => props.parameterChanged(e, props.param.id, props.param.values[0].number)} />

                }
        </div>
    )
}

const useStyles = makeStyles(() => ({
    container: {
        width: "100%",
        height: "75px"
    },
    textField: {
        width: "110px",
        backgroundColor: "white",
        marginBottom: "10px",
    },
    label: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#000000",
    },
}));